angular.module("avant.interceptors").factory "LogoutRedirectInterceptor", [
  "$q", "$injector",
  ($q, $injector) ->
    h =
      response: (response) -> response
      responseError: (rejection) ->
        switch rejection.status
          when 401, 404
            $state = $injector.get('$state')
            $state.transitionTo('redirect', {to: 'logout'})
        $q.reject(rejection)
    h
]
